import { isNumber } from 'util'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, set, values, get } from 'lodash'
import produce from 'immer'

import LocationSelector from '../locationSelector/LocationSelector'
import InputDateField from '../../fields/inputdatefield/InputDateField'
import DisplayField from '../../fields/displayfield/DisplayField'
import InputTimeInput from '../../fields/inputtimeinput/InputTimeInput'
import {
  getAllBerthsAtQuays,
  getFormattedDurationString,
  isNullOrUndefined,
  getKeyByValue,
  getAllProductsAtQuays,
  findMatchingProduct,
  getProductUnit
} from '../../../utils/general'
import InputNumberField from '../../fields/inputnumberfield/InputNumberField'
import InputSelectField from '../../fields/inputselectfield/InputSelectField'
import AdministrativeInfoForm from '../administrativeInfoForm/AdministrativeInfoForm'
import {
  determineBerthName,
  updateBollardEnd,
  updateBollardStart,
  updateCargoEnd,
  updateCargoStart,
  updateDefaultSlack,
  calculateOptimalBollardPositions
} from '../../../utils/terminalVisitUtils'
import CargoSearchField from '../cargosearchfield/CargoSearchField'
import { APP_TERMINAL_IDS, OPERATIONS } from '../../../js/constants'
import Modal from '../../app/customModal/Modal'
import CargoOperationsDetails from '../cargoOperationsDetails/CargoOperationsDetails'
import { getErrorMessageForFormField, isValidTimestamp } from '../../../utils/formUtils'
import InputNumberTextField from '../../fields/inputNumberTextField/inputNumberTextField'
import RadioButtonField from '../../fields/radioButtonField/RadioButtonField'

export default class OrderForm extends PureComponent {
  static propTypes = {
    config: PropTypes.object.isRequired,
    terminalVisitId: PropTypes.string,
    order: PropTypes.object.isRequired,
    errors: PropTypes.object,
    ship: PropTypes.object.isRequired,
    chainCargo: PropTypes.bool.isRequired,
    chainBollard: PropTypes.bool.isRequired,
    cargoRequired: PropTypes.bool.isRequired,
    parallelOrders: PropTypes.bool.isRequired,
    totalDurationDelays: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeCargo: PropTypes.func.isRequired,
    onChainCargo: PropTypes.func.isRequired,
    onChainBollard: PropTypes.func.isRequired,
    readOnly: PropTypes.shape({
      orderDetails: PropTypes.bool.isRequired,
      administrativeDetails: PropTypes.bool.isRequired,
      cargoOperationsDetails: PropTypes.bool.isRequired,
      bollardPosition: PropTypes.bool.isRequired
    }).isRequired,
    authToken: PropTypes.string.isRequired,
    customFetch: PropTypes.func.isRequired,
    isCollapsedVisit: PropTypes.bool,
    showOperationSides: PropTypes.bool.isRequired,
    isParallelVisit: PropTypes.bool.isRequired,
    ordersFormFields: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      showCargoOperationsModal: false
    }
  }

  render() {
    const { order, config, chainCargo, chainBollard, readOnly } = this.props

    const products = getAllProductsAtQuays(this.props.config.quays)
    const visitDuration =
      order.cargoStart && order.cargoEnd && order.cargoEnd > order.cargoStart
        ? getFormattedDurationString(order.cargoStart, order.cargoEnd)
        : null

    const berths = getAllBerthsAtQuays(config.quays)
    const berthName = determineBerthName(berths, order.bollardStart, order.bollardEnd)

    const { identifiers, loadStationName } = this.getCargoOperationsDetails()
    const shipName = this.props.ship ? this.props.ship.name : null
    const terminalName = this.props.config.terminalId
    const selectedProductUnit = getProductUnit(products, this.props.order.product)

    const supportCargoDetails = [
      APP_TERMINAL_IDS.cargillIzegem,
      APP_TERMINAL_IDS.cargillBotlek,
      APP_TERMINAL_IDS.cargillAms,
      APP_TERMINAL_IDS.yara,
      APP_TERMINAL_IDS.teqplay
    ].includes(terminalName)

    console.log('ORDER', { order: this.props.order })

    return (
      <div className="detail-view content side">
        <Modal.Wrapper
          isOpen={this.state.showCargoOperationsModal}
          title={`Cargo Operations Details ${shipName ? '- ' + shipName : ''}`}
          onCloseModal={this.toggleShowCargoOperationDetails}
          fullScreen={[
            APP_TERMINAL_IDS.cargillIzegem,
            APP_TERMINAL_IDS.cargillBotlek,
            APP_TERMINAL_IDS.cargillAms
          ].includes(terminalName)}
        >
          <CargoOperationsDetails
            order={this.props.order}
            ship={this.props.ship}
            identifiers={identifiers}
            berthName={berthName}
            loadStationName={loadStationName}
            authToken={this.props.authToken}
            customFetch={this.props.customFetch}
            readOnly={this.props.readOnly.cargoOperationsDetails}
            closeModal={this.toggleShowCargoOperationDetails}
          />
        </Modal.Wrapper>

        <div className="detail-view-section">
          <h1>Cargo</h1>
          <div className="detailview triple-view">
            <InputSelectField
              title={'Type of operation'}
              fieldName={'operation'}
              fieldValue={this.props.order.operation ? OPERATIONS[this.props.order.operation] : OPERATIONS['loading']}
              onChange={(value, field) => this.handleCargoInputChange(getKeyByValue(OPERATIONS, value), field)}
              options={values(OPERATIONS)}
              setupValue={'loading'}
              previousStatus={'loading'}
              readOnly={readOnly.orderDetails}
            />

            <CargoSearchField
              name={'Product'}
              productName={this.props.order.product}
              operation={this.props.order.operation}
              onChange={this.handleProductChange}
              required={this.props.cargoRequired}
              error={getErrorMessageForFormField(this.props.errors, 'product')}
              quays={this.props.config.quays}
              readOnly={readOnly.orderDetails}
            />

            <InputNumberTextField
              name={'Amount (' + selectedProductUnit + ')'}
              fieldName={'amount'}
              fieldValue={this.props.order.amount}
              required={this.props.cargoRequired}
              error={getErrorMessageForFormField(this.props.errors, 'amount')}
              onChange={this.handleCargoInputChange}
              readOnly={readOnly.orderDetails}
              maxDecimals={4}
              maxNumber={100000000}
            />
          </div>
          <div className="detailview double-view">
            <LocationSelector
              name={'Loading place'}
              fieldName={'origin'}
              location={this.props.order.origin}
              locations={this.props.config.originLocations}
              required={false}
              error={getErrorMessageForFormField(this.props.errors, 'origin')}
              onChange={this.handleChangeInput}
              readOnly={readOnly.orderDetails}
            />

            <LocationSelector
              name={'Discharge place'}
              fieldName={'destination'}
              location={this.props.order.destination}
              locations={this.props.config.destinationLocations}
              required={false}
              error={getErrorMessageForFormField(this.props.errors, 'destination')}
              onChange={this.handleChangeInput}
              readOnly={readOnly.orderDetails}
            />
          </div>
        </div>

        <div className="detail-view-section">
          <h1>Timeframe</h1>
          <div className="detailview triple-view">
            <InputDateField
              name={'Laycan start'}
              fieldName={'laycanStart'}
              fieldValue={this.props.order.laycanStart}
              required={false}
              error={getErrorMessageForFormField(this.props.errors, 'laycanStart')}
              onChange={this.handleLaycanStartChange}
              readOnly={readOnly.orderDetails}
            />
            <InputDateField
              name={'Laycan end'}
              fieldName={'laycanEnd'}
              fieldValue={this.props.order.laycanEnd}
              required={false}
              error={getErrorMessageForFormField(this.props.errors, 'laycanEnd')}
              onChange={this.handleChangeInput}
              readOnly={readOnly.orderDetails}
            />
            <div className="input-date group" />
          </div>

          <div className="detailview triple-view">
            <InputDateField
              name={'Cargo start'}
              fieldName={'cargoStart'}
              fieldValue={this.props.order.cargoStart}
              required={true}
              error={getErrorMessageForFormField(this.props.errors, 'cargoStart')}
              onChange={this.handleCargoStartChange}
              readOnly={readOnly.orderDetails}
            />
            <InputDateField
              name={'Cargo end'}
              fieldName={'cargoEnd'}
              fieldValue={this.props.order.cargoEnd}
              required={true}
              error={getErrorMessageForFormField(this.props.errors, 'cargoEnd')}
              onChange={this.handleCargoEndChange}
              linked={chainCargo}
              linkedTrueMessage={'The cargo end time matches the duration time'}
              linkedFalseMessage={'The cargo end time does not match the duration time'}
              onChangeChain={this.props.onChainCargo}
              readOnly={readOnly.orderDetails}
            />

            <DisplayField title={'Order duration'} value={visitDuration} />
          </div>

          <div className="detailview triple-view">
            <InputTimeInput
              name={'Prior slack time'}
              fieldName={'slackPrior'}
              fieldValue={this.props.order.slackPrior}
              error={getErrorMessageForFormField(this.props.errors, 'slackPrior')}
              onChange={this.onSlackTimeChange}
              readOnly={readOnly.orderDetails}
            />
            <InputTimeInput
              name={'After slack time'}
              fieldName={'slackAfter'}
              fieldValue={this.props.order.slackAfter}
              error={getErrorMessageForFormField(this.props.errors, 'slackAfter')}
              onChange={this.onSlackTimeChange}
              readOnly={readOnly.orderDetails}
            />
            <div className="input-date group" />
          </div>
        </div>

        {this.props.showOperationSides && (
          <div className="detail-view-section">
            <h1>Parallel operation</h1>

            <div className="detailview triple-view checkbox-view">
              {['Left', 'Right'].map((label, index) => (
                <RadioButtonField
                  key={index}
                  name={label}
                  fieldName={'parallelGroup'}
                  fieldValue={index}
                  checked={this.props.order.parallelGroup === index}
                  onChange={this.onSelectParallelGroup}
                  readOnly={readOnly.orderDetails}
                />
              ))}
            </div>
          </div>
        )}

        {this.props.isCollapsedVisit === undefined ||
          (this.props.isCollapsedVisit === false && (
            <div className="detail-view-section">
              <h1>Position</h1>
              <div className="detailview triple-view">
                <InputNumberField
                  name={'Start bollard'}
                  fieldName={'bollardStart'}
                  fieldValue={this.props.order.bollardStart}
                  required={true}
                  error={getErrorMessageForFormField(this.props.errors, 'bollardStart')}
                  onChange={this.onBollardStartInputChange}
                  readOnly={readOnly.bollardPosition}
                />
                <InputNumberField
                  name={'End bollard'}
                  fieldName={'bollardEnd'}
                  fieldValue={this.props.order.bollardEnd}
                  required={true}
                  error={getErrorMessageForFormField(this.props.errors, 'bollardEnd')}
                  onChange={this.onBollardEndInputChange}
                  linked={chainBollard}
                  linkedTrueMessage={'The end bollard matches the length of the ship'}
                  linkedFalseMessage={'The end bollard does not match the length of the ship'}
                  onChangeChain={this.props.onChainBollard}
                  readOnly={readOnly.bollardPosition}
                />
                {(!isNullOrUndefined(this.props.order.bollardStart) &&
                  !isNullOrUndefined(this.props.order.bollardEnd)) ||
                (this.props.order.ship && this.props.order.ship.length) ? (
                  <InputSelectField
                    title={'Berth'}
                    fieldName={'berth'}
                    fieldValue={berthName}
                    onChange={this.handleSelectBerth}
                    options={this.getAllBerthOptions(berths, berthName)}
                    emptyOption
                    emptyOptionText={'Select a berth'}
                    readOnly={readOnly.bollardPosition}
                  />
                ) : null}
              </div>
            </div>
          ))}

        <div className="detail-view-section">
          <h1>Cargo Operation details</h1>
          <div className="detailview">
            <InputNumberField
              name={'Actual cargo amount (' + selectedProductUnit + ')'}
              fieldName={'actualAmount'}
              fieldValue={this.props.order.actualAmount}
              required={false}
              error={getErrorMessageForFormField(this.props.errors, 'actualAmount')}
              onChange={this.handleChangeInput}
              readOnly={readOnly.orderDetails}
            />
          </div>
          <div className="detailview">
            {supportCargoDetails ? (
              <button
                className="btn"
                disabled={this.props.terminalVisitId === undefined}
                onClick={this.toggleShowCargoOperationDetails}
                title="Open a modal displaying the cargo operation details"
              >
                Cargo operation details
              </button>
            ) : null}
          </div>
        </div>

        <AdministrativeInfoForm
          administrativeInfo={this.props.order.administrativeInfo}
          errors={get(this.props.errors, 'administrativeInfo') || {}}
          onChange={this.handleChangeAdministrativeInfo}
          readOnly={readOnly.administrativeDetails}
        />
      </div>
    )
  }

  toggleShowCargoOperationDetails = () => {
    this.setState({ showCargoOperationsModal: !this.state.showCargoOperationsModal })
  }

  getCargoOperationsDetails = () => {
    const productInformation = getAllProductsAtQuays(this.props.config.quays)
    const loadStation = this.props.order
      ? findMatchingProduct(this.props.order.product, this.props.order.operation, productInformation)
      : null
    const loadStationName = loadStation ? loadStation.product : null

    const identifiers = {
      terminalId: this.props.config.terminalId,
      terminalVisitId: this.props.terminalVisitId,
      orderId: this.props.order.uuid
    }

    return { identifiers, loadStationName }
  }

  handleChangeInput = (value, field) => {
    const updatedOrder = cloneDeep(this.props.order)
    set(updatedOrder, field, value)
    this.props.onChange(updatedOrder)
  }

  handleChangeAdministrativeInfo = administrativeInfo => {
    const updatedOrder = cloneDeep(this.props.order)
    set(updatedOrder, 'administrativeInfo', administrativeInfo)
    this.props.onChange(updatedOrder)
  }

  /**
   * When the laycan starting time changes
   */
  handleLaycanStartChange = laycanStart => {
    const { config, totalDurationDelays, chainCargo } = this.props
    const updatedOrder = cloneDeep(this.props.order)

    updatedOrder.laycanStart = laycanStart

    // always update cargoStart when laycanStart valid date is changed
    if (isValidTimestamp(laycanStart)) {
      updatedOrder.cargoStart = laycanStart
    }

    if (chainCargo) {
      updateCargoEnd(updatedOrder, config, totalDurationDelays)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  handleCargoStartChange = startTime => {
    const { order, config, totalDurationDelays, chainCargo } = this.props
    const updatedOrder = cloneDeep(order)

    updatedOrder.cargoStart = startTime
    if (chainCargo) {
      updateCargoEnd(updatedOrder, config, totalDurationDelays)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  handleCargoEndChange = endTime => {
    const { config, totalDurationDelays, chainCargo } = this.props
    const updatedOrder = cloneDeep(this.props.order)

    updatedOrder.cargoEnd = endTime
    if (chainCargo) {
      updateCargoStart(updatedOrder, config, totalDurationDelays)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  onSlackTimeChange = (value, field) => {
    const { order, config, totalDurationDelays, chainCargo } = this.props
    const updatedOrder = cloneDeep(order)

    set(updatedOrder, field, value)
    if (chainCargo) {
      updateCargoEnd(updatedOrder, config, totalDurationDelays)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  onSelectParallelGroup = (value, field) => {
    const { order, config, totalDurationDelays, chainCargo } = this.props
    const updatedOrder = cloneDeep(order)

    set(updatedOrder, field, value)

    if (chainCargo) {
      updateCargoEnd(updatedOrder, config, totalDurationDelays)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  onBollardStartInputChange = bollardStart => {
    const { order, ship, config, chainBollard } = this.props
    const updatedOrder = cloneDeep(order)

    updatedOrder.bollardStart = bollardStart
    if (chainBollard) {
      updateBollardEnd(updatedOrder, ship, config)
    }

    this.props.onChange(updatedOrder)
  }

  /**
   * When the value of a form input field changes
   */
  onBollardEndInputChange = bollardEnd => {
    const { order, ship, config, chainBollard } = this.props
    const updatedOrder = cloneDeep(order)

    updatedOrder.bollardEnd = bollardEnd
    if (chainBollard) {
      updateBollardStart(updatedOrder, ship, config)
    }

    this.props.onChange(updatedOrder)
  }

  handleProductChange = productObject => {
    const updatedOrder = cloneDeep(this.props.order)
    updatedOrder.product = productObject.name
    updatedOrder.productGroup = productObject.productGroup

    this.applyChangedCargo(updatedOrder)
  }

  handleCargoInputChange = (value, field) => {
    const updatedOrder = cloneDeep(this.props.order)
    set(updatedOrder, field, value)

    this.applyChangedCargo(updatedOrder)
  }

  applyChangedCargo = updatedOrder => {
    const {
      order,
      ship,
      config,
      totalDurationDelays,
      chainCargo,
      chainBollard,
      isParallelVisit,
      ordersFormFields
    } = this.props

    if (chainCargo) {
      updateCargoEnd(updatedOrder, config, totalDurationDelays)
    }

    const productChanged = updatedOrder.product !== order.product
    if (chainBollard && productChanged && !isParallelVisit) {
      const { bollardStart, bollardEnd } = calculateOptimalBollardPositions(ship, config, updatedOrder)
      updatedOrder.bollardStart = bollardStart
      updatedOrder.bollardEnd = bollardEnd
    }

    console.log(JSON.stringify({ updatedOrder, order }))

    //if parallel order use the bollards from the first order
    if (chainBollard && productChanged && isParallelVisit && ordersFormFields.length >= 2) {
      const { bollardStart, bollardEnd, cargoStart, cargoEnd } = ordersFormFields[0]

      if (isNumber(bollardStart) && isNumber(bollardEnd)) {
        updatedOrder.bollardStart = bollardStart
        updatedOrder.bollardEnd = bollardEnd

        if ((isValidTimestamp(cargoStart), isValidTimestamp(cargoEnd), ordersFormFields.length === 2)) {
          updatedOrder.cargoStart = cargoStart
          updatedOrder.cargoEnd = cargoEnd
        }
      } else {
        //if bollard fields are emtpy calculate optimal bollard position
        const { bollardStart, bollardEnd } = calculateOptimalBollardPositions(ship, config, updatedOrder)
        updatedOrder.bollardStart = bollardStart
        updatedOrder.bollardEnd = bollardEnd
      }
    }

    updateDefaultSlack(updatedOrder, ship, config)

    this.props.onChangeCargo(updatedOrder)
  }

  handleSelectBerth = selectedTerminalName => {
    const berth = getAllBerthsAtQuays(this.props.config.quays).find(b => b.terminalName === selectedTerminalName)

    if (!berth) {
      return
    }

    const { config, order, ship } = this.props
    const { bollardStart, bollardEnd } = calculateOptimalBollardPositions(ship, config, order, undefined, berth)
    this.props.onChainBollard(true)

    const newOrder = produce(order, updateOrder => {
      updateOrder.bollardStart = bollardStart
      updateOrder.bollardEnd = bollardEnd
    })

    this.props.onChange(newOrder)
  }

  /**
   * @param {TerminalPlannerBerth[]}berths
   * @param {string} berthName
   */
  getAllBerthOptions = (berths, berthName) => {
    const allBerthNames = berths.map(b => b.terminalName)

    // Sometimes berthName is not in array, when berthName is multiple berths
    if (berthName && !allBerthNames.includes(berthName)) {
      allBerthNames.unshift(berthName)
    }

    return allBerthNames
  }
}
